// Mock data for all modules

export const countries = [
  { id: 1, name: 'Almaniya', code: 'DE', createdAt: '2024-01-15', isActive: true },
  { id: 2, name: 'İngiltərə', code: 'GB', createdAt: '2024-01-16', isActive: true },
  { id: 3, name: 'ABŞ', code: 'US', createdAt: '2024-01-17', isActive: true },
  { id: 4, name: 'Kanada', code: 'CA', createdAt: '2024-01-18', isActive: false },
  { id: 5, name: 'Avstriyalya', code: 'AU', createdAt: '2024-01-19', isActive: true },
];

export const cities = [
  { id: 1, name: 'Berlin', countryId: 1, country: 'Almaniya', isActive: false, createdAt: '2024-01-15' },
  { id: 2, name: 'München', countryId: 1, country: 'Almaniya', isActive: true, createdAt: '2024-01-16' },
  { id: 3, name: 'London', countryId: 2, country: 'İngiltərə', isActive: true, createdAt: '2024-01-17' },
  { id: 4, name: 'Manchester', countryId: 2, country: 'İngiltərə', isActive: true, createdAt: '2024-01-18' },
  { id: 5, name: 'New York', countryId: 3, country: 'ABŞ', isActive: true, createdAt: '2024-01-19' },
  { id: 6, name: 'Los Angeles', countryId: 3, country: 'ABŞ', isActive: true, createdAt: '2024-01-20' },
  { id: 7, name: 'Toronto', countryId: 4, country: 'Kanada', isActive: true, createdAt: '2024-01-21' },
  { id: 8, name: 'Vancouver', countryId: 4, country: 'Kanada', isActive: true, createdAt: '2024-01-22' },
  { id: 9, name: 'Sidney', countryId: 5, country: 'Avstriyalya', isActive: true, createdAt: '2024-01-23' },
  { id: 10, name: 'Melbourne', countryId: 5, country: 'Avstriyalya', isActive: true, createdAt: '2024-01-24' },
];

export const universities = [
  { 
    id: 1, 
    name: 'Technical University of Munich', 
    cityId: 2, 
    city: 'München', 
    country: 'Almaniya', 
    ranking: 1,
    representatives: 'Dr. Schmidt, Prof. Weber',
    focalPoint: 'Anna Müller (anna.muller@tum.de)',
    phone: '+49 89 289 01',
    email: 'international@tum.de',
    address: 'Arcisstraße 21, 80333 München, Germany',
    website: 'https://www.tum.de',
    requiredDocuments: 'Diplom, Transkript, Motivasiya məktubu, CV, İngilis dili sertifikatı, Referans məktubları',
    degree: 'Bakalavr, Magistr, Doktorantura',
    submissionDeadline: '15 Mart 2024',
    averageCost: '8000-12000 EUR/il',
    comments: 'Texniki sahələr üzrə güclü universitet. IELTS minimum 6.5 tələb edir.',
    isActive: true,
    createdAt: '2024-01-15'
  },
  { 
    id: 2, 
    name: 'University of Oxford', 
    cityId: 3, 
    city: 'London', 
    country: 'İngiltərə', 
    ranking: 2,
    representatives: 'Dr. Johnson, Prof. Smith',
    focalPoint: 'Sarah Williams (s.williams@ox.ac.uk)',
    phone: '+44 1865 270000',
    email: 'admissions@ox.ac.uk',
    address: 'Wellington Square, Oxford OX1 2JD, United Kingdom',
    website: 'https://www.ox.ac.uk',
    requiredDocuments: 'Diplom, Transkript, Personal Statement, CV, İngilis dili sertifikatı, 2 Referans məktubu',
    degree: 'Bakalavr, Magistr, Doktorantura',
    submissionDeadline: '31 Yanvar 2024',
    averageCost: '35000-45000 GBP/il',
    comments: 'Ən prestijli universitetlərdən biri. Çox yüksək akademik tələblər.',
    isActive: true,
    createdAt: '2024-01-16'
  },
  { 
    id: 3, 
    name: 'Harvard University', 
    cityId: 5, 
    city: 'New York', 
    country: 'ABŞ', 
    ranking: 3,
    representatives: 'Prof. Anderson, Dr. Brown',
    focalPoint: 'Michael Davis (m.davis@harvard.edu)',
    phone: '+1 617 495 1000',
    email: 'college@harvard.edu',
    address: 'Massachusetts Hall, Cambridge, MA 02138, USA',
    website: 'https://www.harvard.edu',
    requiredDocuments: 'Diplom, Transkript, Essays, CV, SAT/GRE, TOEFL/IELTS, Referans məktubları',
    degree: 'Bakalavr, Magistr, Doktorantura',
    submissionDeadline: '1 Yanvar 2024',
    averageCost: '50000-65000 USD/il',
    comments: 'Dünyanın ən yaxşı universitetlərindən biri. Çox rəqabətli qəbul prosesi.',
    isActive: true,
    createdAt: '2024-01-17'
  },
  { 
    id: 4, 
    name: 'University of Toronto', 
    cityId: 7, 
    city: 'Toronto', 
    country: 'Kanada', 
    ranking: 4,
    representatives: 'Dr. Wilson, Prof. Taylor',
    focalPoint: 'Jennifer Lee (j.lee@utoronto.ca)',
    phone: '+1 416 978 2011',
    email: 'international@utoronto.ca',
    address: '27 King\'s College Cir, Toronto, ON M5S 1A1, Canada',
    website: 'https://www.utoronto.ca',
    requiredDocuments: 'Diplom, Transkript, Statement of Purpose, CV, İngilis dili sertifikatı',
    degree: 'Bakalavr, Magistr',
    submissionDeadline: '1 Fevral 2024',
    averageCost: '25000-35000 CAD/il',
    comments: 'Kanadanın ən yaxşı universitetlərindən biri. Çoxsahəli təhsil imkanları.',
    isActive: false,
    createdAt: '2024-01-18'
  },
  { 
    id: 5, 
    name: 'University of Sydney', 
    cityId: 9, 
    city: 'Sidney', 
    country: 'Avstriyalya', 
    ranking: 5,
    representatives: 'Prof. Clark, Dr. White',
    focalPoint: 'Emma Thompson (e.thompson@sydney.edu.au)',
    phone: '+61 2 9351 2222',
    email: 'international@sydney.edu.au',
    address: 'Camperdown NSW 2006, Australia',
    website: 'https://www.sydney.edu.au',
    requiredDocuments: 'Diplom, Transkript, Personal Statement, CV, IELTS, Referans məktubu',
    degree: 'Bakalavr, Magistr, Doktorantura',
    submissionDeadline: '30 Noyabr 2024',
    averageCost: '30000-40000 AUD/il',
    comments: 'Avstriyalyanın aparıcı universitetlərindən biri. Beynəlxalq tələbələr üçün əlverişli.',
    isActive: true,
    createdAt: '2024-01-19'
  },
];

export const universityPrograms = [
  { 
    id: 1, 
    name: 'Computer Science', 
    universityId: 1, 
    university: 'Technical University of Munich', 
    degree: 'Magistr', 
    duration: '2 il', 
    tuitionAmount: '8000',
    tuitionCurrency: 'EUR',
    isActive: true,
    createdAt: '2024-01-20',
    description: 'Komputer elmlərində müasir proqram təminatı və sistemlər'
  },
  { 
    id: 2, 
    name: 'Business Administration', 
    universityId: 2, 
    university: 'University of Oxford', 
    degree: 'Magistr', 
    duration: '1 il', 
    tuitionAmount: '45000',
    tuitionCurrency: 'GBP',
    isActive: true,
    createdAt: '2024-01-21',
    description: 'Beynəlxalq biznes idarəçiliyi və strateji menecment'
  },
  { 
    id: 3, 
    name: 'Medicine', 
    universityId: 3, 
    university: 'Harvard University', 
    degree: 'Doktorantura', 
    duration: '4 il', 
    tuitionAmount: '65000',
    tuitionCurrency: 'USD',
    isActive: true,
    createdAt: '2024-01-22',
    description: 'Ümumi təbabət və klinik tədqiqatlar'
  },
  { 
    id: 4, 
    name: 'Engineering', 
    universityId: 4, 
    university: 'University of Toronto', 
    degree: 'Bakalavr', 
    duration: '4 il', 
    tuitionAmount: '25000',
    tuitionCurrency: 'CAD',
    isActive: false,
    createdAt: '2024-01-23',
    description: 'Mexanika və struktur mühendisliyi'
  },
  { 
    id: 5, 
    name: 'Law', 
    universityId: 5, 
    university: 'University of Sydney', 
    degree: 'Magistr', 
    duration: '2 il', 
    tuitionAmount: '35000',
    tuitionCurrency: 'AUD',
    isActive: true,
    createdAt: '2024-01-24',
    description: 'Beynəlxalq hüquq və kommersiya qanunları'
  },
  { 
    id: 6, 
    name: 'Psychology', 
    universityId: 2, 
    university: 'University of Oxford', 
    degree: 'Bakalavr', 
    duration: '3 il', 
    tuitionAmount: '38000',
    tuitionCurrency: 'GBP',
    isActive: true,
    createdAt: '2024-01-25',
    description: 'Klinik psixologiya və davranış tədqiqatları'
  },
];

export const consultants = [
  { 
    id: 1, 
    name: 'Əli Məmmədov', 
    email: 'ali@unidestin.az', 
    phone: '+994502345678', 
    isActive: true, 
    joiningDate: '2023-01-15',
    position: 'Baş Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '2000 AZN',
    address: 'Bakı şəhəri, Nəsimi rayonu, Azadlıq prospekti 123',
    birthDate: '1990-05-20',
    education: 'Bakı Dövlət Universiteti, Beynəlxalq Münasibətlər fakültəsi',
    experience: '5 il beynəlxalq təhsil sahəsində təcrübə',
    languages: 'Azərbaycan, İngilis, Rus',
    specialization: 'Almaniya, İngiltərə universitetləri',
    notes: 'Çox təcrübəli konsultant, tələbələrlə çox yaxşı əlaqəsi var',
    emergencyContact: 'Fatimə Məmmədova (Ana)',
    emergencyPhone: '+994552345679'
  },
  { 
    id: 2, 
    name: 'Ayşə Həsənova', 
    email: 'ayse@unidestin.az', 
    phone: '+994553456789', 
    isActive: true, 
    joiningDate: '2023-02-20',
    position: 'Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1500 AZN',
    address: 'Bakı şəhəri, Yasamal rayonu, Mərdəkan qəsəbəsi',
    birthDate: '1992-08-15',
    education: 'ADA Universiteti, Biznes fakültəsi',
    experience: '3 il təhsil məsləhətçiliyi təcrübəsi',
    languages: 'Azərbaycan, İngilis, Türk',
    specialization: 'ABŞ, Kanada universitetləri',
    notes: 'Tələbələrə çox yaxşı yardım edir, STEM sahələrində güclü',
    emergencyContact: 'Əli Həsənov (Əri)',
    emergencyPhone: '+994553456788'
  },
  { 
    id: 3, 
    name: 'Rəşad Quliyev', 
    email: 'resad@unidestin.az', 
    phone: '+994704567890', 
    isActive: true, 
    joiningDate: '2023-03-10',
    position: 'Yeni Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1200 AZN',
    address: 'Bakı şəhəri, Səbail rayonu, 28 May küçəsi 45',
    birthDate: '1995-03-12',
    education: 'Azərbaycan Dillər Universiteti, İngilis dili fakültəsi',
    experience: '1 il təhsil sahəsində təcrübə',
    languages: 'Azərbaycan, İngilis, Alman',
    specialization: 'İngiltərə, Avstraliya universitetləri',
    notes: 'Yeni başlayıb, çox səylə işləyir və öyrənir',
    emergencyContact: 'Gülnarə Quliyeva (Ana)',
    emergencyPhone: '+994704567891'
  },
  { 
    id: 4, 
    name: 'Gülnar Əliyeva', 
    email: 'gulnar@unidestin.az', 
    phone: '+994515678901', 
    isActive: false, 
    joiningDate: '2023-04-05',
    position: 'Keçmiş Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1400 AZN',
    address: 'Bakı şəhəri, Xətai rayonu, Koroğlu küçəsi 78',
    birthDate: '1988-11-25',
    education: 'Qərb Universiteti, Psixologiya fakültəsi',
    experience: '4 il təhsil məsləhətçiliği təcrübəsi',
    languages: 'Azərbaycan, İngilis, Fars',
    specialization: 'İran, Türkiyə universitetləri',
    notes: 'Şəxsi səbəblərdən işdən ayrılıb, çox yaxşı konsultant idi',
    emergencyContact: 'Elnur Əliyev (Qardaş)',
    emergencyPhone: '+994515678902'
  },
  { 
    id: 5, 
    name: 'Leyla Nəbiyeva', 
    email: 'leyla@unidestin.az', 
    phone: '+994556789012', 
    isActive: true, 
    joiningDate: '2023-05-12',
    position: 'Senior Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1800 AZN',
    address: 'Bakı şəhəri, Binəqədi rayonu, Binə qəsəbəsi',
    birthDate: '1987-09-30',
    education: 'Azərbaycan Texniki Universiteti, Komputer Mühendisliyi',
    experience: '6 il beynəlxalq təhsil sahəsində təcrübə',
    languages: 'Azərbaycan, İngilis, Fransız',
    specialization: 'Fransa, İsveçrə universitetləri',
    notes: 'Texniki sahələrdə çox güclü, PhD proqramları üzrə ekspert',
    emergencyContact: 'Kamran Nəbiyev (Əri)',
    emergencyPhone: '+994556789013'
  },
  { 
    id: 6, 
    name: 'Orxan Məhərrəmov', 
    email: 'orxan@unidestin.az', 
    phone: '+994507890123', 
    isActive: true, 
    joiningDate: '2023-06-18',
    position: 'Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1600 AZN',
    address: 'Bakı şəhəri, Suraxanı rayonu, Hövsan qəsəbəsi',
    birthDate: '1993-12-08',
    education: 'UNEC, Beynəlxalq İqtisadiyyat fakültəsi',
    experience: '2 il təhsil məsləhətçiliyi təcrübəsi',
    languages: 'Azərbaycan, İngilis, İspan',
    specialization: 'İspaniya, İtaliya universitetləri',
    notes: 'Avropa universitetləri haqqında geniş bilgisi var',
    emergencyContact: 'Səbinə Məhərrəmova (Bacı)',
    emergencyPhone: '+994507890124'
  },
  { 
    id: 7, 
    name: 'Səbinə Qədirzadə', 
    email: 'sebine@unidestin.az', 
    phone: '+994558901234', 
    isActive: true, 
    joiningDate: '2023-07-25',
    position: 'Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1450 AZN',
    address: 'Bakı şəhəri, Nərimanov rayonu, Əhmədli qəsəbəsi',
    birthDate: '1994-04-22',
    education: 'Bakı Slavyan Universiteti, Filologiya fakültəsi',
    experience: '2 il təhsil sahəsində təcrübə',
    languages: 'Azərbaycan, İngilis, Rus, Çex',
    specialization: 'Çexiya, Polşa, Macarıstan universitetləri',
    notes: 'Şərqi Avropa ölkələri üzrə mütəxəssis',
    emergencyContact: 'Rəşid Qədirzadə (Ata)',
    emergencyPhone: '+994558901235'
  },
  { 
    id: 8, 
    name: 'Fərid Əsgərov', 
    email: 'ferid@unidestin.az', 
    phone: '+994709012345', 
    isActive: true, 
    joiningDate: '2023-08-14',
    position: 'Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1550 AZN',
    address: 'Bakı şəhəri, Qaradağ rayonu, Lökbatan qəsəbəsi',
    birthDate: '1991-07-11',
    education: 'Azərbaycan Memarlıq və İnşaat Universiteti',
    experience: '3 il təhsil məsləhətçiliyi təcrübəsi',
    languages: 'Azərbaycan, İngilis, Alman, Holland',
    specialization: 'Hollandiya, Belçika universitetləri',
    notes: 'Memarlıq və mühendislik sahələrində güclü',
    emergencyContact: 'Nigar Əsgərova (Həyat yoldaşı)',
    emergencyPhone: '+994709012346'
  },
  { 
    id: 9, 
    name: 'Könül Həmidova', 
    email: 'konul@unidestin.az', 
    phone: '+994510123456', 
    isActive: true, 
    joiningDate: '2023-09-03',
    position: 'Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1400 AZN',
    address: 'Bakı şəhəri, Xəzər rayonu, Mərdəkan qəsəbəsi',
    birthDate: '1996-01-18',
    education: 'Azərbaycan Tibb Universiteti, Həkim fakültəsi',
    experience: '1 il təhsil sahəsində təcrübə',
    languages: 'Azərbaycan, İngilis, Türk',
    specialization: 'Türkiyə, Kipr universitetləri',
    notes: 'Tibb sahələri üzrə mütəxəssis, yeni başlayıb',
    emergencyContact: 'Əli Həmidov (Ata)',
    emergencyPhone: '+994510123457'
  },
  { 
    id: 10, 
    name: 'Tural Bayramov', 
    email: 'tural@unidestin.az', 
    phone: '+994551234567', 
    isActive: true, 
    joiningDate: '2023-10-20',
    position: 'Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1650 AZN',
    address: 'Bakı şəhəri, Sabunçu rayonu, Zabrat qəsəbəsi',
    birthDate: '1989-11-05',
    education: 'Azərbaycan Dövlət Neft və Sənaye Universiteti',
    experience: '4 il beynəlxalq təhsil sahəsində təcrübə',
    languages: 'Azərbaycan, İngilis, Norveç',
    specialization: 'Norveç, İsveç, Danimarka universitetləri',
    notes: 'Skandinav ölkələri üzrə ekspert, neft mühendisliyi',
    emergencyContact: 'Aynur Bayramova (Ana)',
    emergencyPhone: '+994551234568'
  },
  { 
    id: 11, 
    name: 'Aynur Rəsulova', 
    email: 'aynur@unidestin.az', 
    phone: '+994702345678', 
    isActive: true, 
    joiningDate: '2023-11-08',
    position: 'Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1500 AZN',
    address: 'Bakı şəhəri, Pirallahı rayonu, Pirallahı adası',
    birthDate: '1992-06-14',
    education: 'Azərbaycan Dövlət İqtisad Universiteti',
    experience: '2 il təhsil məsləhətçiliyi təcrübəsi',
    languages: 'Azərbaycan, İngilis, Yapon',
    specialization: 'Yaponiya, Cənubi Koreya universitetləri',
    notes: 'Asiya ölkələri üzrə mütəxəssis, texnologiya sahələri',
    emergencyContact: 'Rəsul Rəsulov (Ata)',
    emergencyPhone: '+994702345679'
  },
  { 
    id: 12, 
    name: 'Elçin Vəliyev', 
    email: 'elchin@unidestin.az', 
    phone: '+994513456789', 
    isActive: true, 
    joiningDate: '2023-12-15',
    position: 'Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1350 AZN',
    address: 'Bakı şəhəri, Nizami rayonu, Əhmədli qəsəbəsi',
    birthDate: '1997-03-27',
    education: 'Azərbaycan Universiteti, Hüquq fakültəsi',
    experience: '1 il təhsil sahəsində təcrübə',
    languages: 'Azərbaycan, İngilis, Ərəb',
    specialization: 'BƏƏ, Qətər, Səudiyyə Ərəbistanı universitetləri',
    notes: 'Ərəb ölkələri üzrə yeni mütəxəssis',
    emergencyContact: 'Gülşən Vəliyeva (Ana)',
    emergencyPhone: '+994513456780'
  },
  { 
    id: 13, 
    name: 'Məryəm Əhmədova', 
    email: 'meryem@unidestin.az', 
    phone: '+994554567890', 
    isActive: true, 
    joiningDate: '2024-01-10',
    position: 'Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1450 AZN',
    address: 'Bakı şəhəri, Səbail rayonu, İçərişəhər',
    birthDate: '1990-08-09',
    education: 'Bakı Musiqi Akademiyası, Musiqi nəzəriyyəsi',
    experience: '3 il təhsil məsləhətçiliği təcrübəsi',
    languages: 'Azərbaycan, İngilis, İtalyan',
    specialization: 'İtaliya, Avstriya musiqi və incəsənət universitetləri',
    notes: 'İncəsənət sahələri üzrə mütəxəssis',
    emergencyContact: 'Əhməd Əhmədov (Ata)',
    emergencyPhone: '+994554567891'
  },
  { 
    id: 14, 
    name: 'Ramin Həsənov', 
    email: 'ramin@unidestin.az', 
    phone: '+994705678901', 
    isActive: true, 
    joiningDate: '2024-02-05',
    position: 'Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1600 AZN',
    address: 'Bakı şəhəri, Yasamal rayonu, Yeni Yasamal',
    birthDate: '1988-12-16',
    education: 'Azərbaycan Dövlət Pedaqoji Universiteti',
    experience: '5 il təhsil sahəsində təcrübə',
    languages: 'Azərbaycan, İngilis, Fin',
    specialization: 'Finlandiya, Estoniya universitetləri',
    notes: 'Baltik ölkələri və Finlandiya üzrə ekspert',
    emergencyContact: 'Səadət Həsənova (Həyat yoldaşı)',
    emergencyPhone: '+994705678902'
  },
  { 
    id: 15, 
    name: 'Gülşən Məmmədova', 
    email: 'gulsen@unidestin.az', 
    phone: '+994516789012', 
    isActive: true, 
    joiningDate: '2024-03-12',
    position: 'Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1400 AZN',
    address: 'Bakı şəhəri, Nəsimi rayonu, Koroğlu Rəhimov küçəsi',
    birthDate: '1995-05-03',
    education: 'Azərbaycan Dövlət Bədən Tərbiyəsi və İdman Akademiyası',
    experience: '1 il təhsil məsləhətçiliyi təcrübəsi',
    languages: 'Azərbaycan, İngilis, Portuqal',
    specialization: 'Portuqaliya, Braziliya universitetləri',
    notes: 'İdman təhsili sahələri üzrə mütəxəssis',
    emergencyContact: 'Məmməd Məmmədov (Qardaş)',
    emergencyPhone: '+994516789013'
  },
  { 
    id: 16, 
    name: 'Kamran Əlizadə', 
    email: 'kamran@unidestin.az', 
    phone: '+994557890123', 
    isActive: true, 
    joiningDate: '2024-04-08',
    position: 'Senior Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1750 AZN',
    address: 'Bakı şəhəri, Xətai rayonu, Əhmədli qəsəbəsi',
    birthDate: '1986-10-21',
    education: 'Azərbaycan Respublikası Prezidenti yanında Dövlət İdarəçilik Akademiyası',
    experience: '7 il beynəlxalq təhsil sahəsində təcrübə',
    languages: 'Azərbaycan, İngilis, Çin',
    specialization: 'Çin, Sinqapur, Honq Konq universitetləri',
    notes: 'Asiya-Sakit okean regionu üzrə ekspert',
    emergencyContact: 'Əli Əlizadə (Ata)',
    emergencyPhone: '+994557890124'
  },
  { 
    id: 17, 
    name: 'Nigar Sultanova', 
    email: 'nigar@unidestin.az', 
    phone: '+994708901234', 
    isActive: true, 
    joiningDate: '2024-05-14',
    position: 'Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1500 AZN',
    address: 'Bakı şəhəri, Suraxanı rayonu, Qaraçuxur qəsəbəsi',
    birthDate: '1993-02-28',
    education: 'Azərbaycan Dövlət Mədəniyyət və İncəsənət Universiteti',
    experience: '2 il təhsil sahəsində təcrübə',
    languages: 'Azərbaycan, İngilis, Yunan',
    specialization: 'Yunanıstan, Kipr universitetləri',
    notes: 'Mədəniyyət və incəsənət sahələri üzrə mütəxəssis',
    emergencyContact: 'Sultan Sultanov (Ata)',
    emergencyPhone: '+994708901235'
  },
  { 
    id: 18, 
    name: 'Vüsal Qasımov', 
    email: 'vusal@unidestin.az', 
    phone: '+994519012345', 
    isActive: true, 
    joiningDate: '2024-06-20',
    position: 'Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1550 AZN',
    address: 'Bakı şəhəri, Binəqədi rayonu, Biləcəri qəsəbəsi',
    birthDate: '1991-09-12',
    education: 'Azərbaycan Dövlət Aqrar Universiteti',
    experience: '3 il təhsil məsləhətçiliği təcrübəsi',
    languages: 'Azərbaycan, İngilis, Danimarka',
    specialization: 'Danimarka, İslandiya universitetləri',
    notes: 'Kənd təsərrüfatı və ekoloji elmlər üzrə mütəxəssis',
    emergencyContact: 'Qasım Qasımov (Ata)',
    emergencyPhone: '+994519012346'
  },
  { 
    id: 19, 
    name: 'Səidə Rəhimova', 
    email: 'seide@unidestin.az', 
    phone: '+994550123456', 
    isActive: false, 
    joiningDate: '2024-07-15',
    position: 'Keçmiş Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1450 AZN',
    address: 'Bakı şəhəri, Qaradağ rayonu, Sahil qəsəbəsi',
    birthDate: '1994-11-07',
    education: 'Azərbaycan Dövlət Dəniz Akademiyası',
    experience: '1 il təhsil sahəsində təcrübə',
    languages: 'Azərbaycan, İngilis, Rus',
    specialization: 'Rusiya, Belarus universitetləri',
    notes: 'Ailə səbəbləri ilə işdən ayrılıb',
    emergencyContact: 'Rəhim Rəhimov (Ata)',
    emergencyPhone: '+994550123457'
  },
  { 
    id: 20, 
    name: 'Elnur Məhəmmədov', 
    email: 'elnur@unidestin.az', 
    phone: '+994701234567', 
    isActive: true, 
    joiningDate: '2024-08-10',
    position: 'Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1600 AZN',
    address: 'Bakı şəhəri, Sabunçu rayonu, Maştağa qəsəbəsi',
    birthDate: '1987-04-15',
    education: 'Azərbaycan Texnologiya Universiteti',
    experience: '4 il beynəlxalq təhsil sahəsində təcrübə',
    languages: 'Azərbaycan, İngilis, Malayziya',
    specialization: 'Malayziya, Tayland universitetləri',
    notes: 'Cənub-Şərqi Asiya ölkələri üzrə mütəxəssis',
    emergencyContact: 'Məhəmməd Məhəmmədov (Ata)',
    emergencyPhone: '+994701234568'
  },
  { 
    id: 21, 
    name: 'Lalə Əliyeva', 
    email: 'lale@unidestin.az', 
    phone: '+994512345678', 
    isActive: true, 
    joiningDate: '2024-09-05',
    position: 'Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1400 AZN',
    address: 'Bakı şəhəri, Pirallahı rayonu, Pirallahı qəsəbəsi',
    birthDate: '1996-07-23',
    education: 'Azərbaycan Dövlət Turizm və Menecment Universiteti',
    experience: '1 il təhsil məsləhətçiliyi təcrübəsi',
    languages: 'Azərbaycan, İngilis, Hindistan',
    specialization: 'Hindistan, Şri Lanka universitetləri',
    notes: 'Turizm və menecment sahələri üzrə yeni mütəxəssis',
    emergencyContact: 'Əli Əliyev (Qardaş)',
    emergencyPhone: '+994512345679'
  },
  { 
    id: 22, 
    name: 'Rəşid Həsənzadə', 
    email: 'resid@unidestin.az', 
    phone: '+994553456789', 
    isActive: true, 
    joiningDate: '2024-10-12',
    position: 'Senior Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1850 AZN',
    address: 'Bakı şəhəri, Nərimanov rayonu, Nərimanov qəsəbəsi',
    birthDate: '1985-01-30',
    education: 'Azərbaycan Dövlət Universiteti, Fizika-Riyaziyyat fakültəsi',
    experience: '8 il beynəlxalq təhsil sahəsində təcrübə',
    languages: 'Azərbaycan, İngilis, İsrail',
    specialization: 'İsrail, Ukrayna universitetləri',
    notes: 'Riyaziyyat və fizika sahələri üzrə ekspert',
    emergencyContact: 'Həsən Həsənzadə (Ata)',
    emergencyPhone: '+994553456780'
  },
  { 
    id: 23, 
    name: 'Günel Bayramova', 
    email: 'gunel@unidestin.az', 
    phone: '+994704567890', 
    isActive: true, 
    joiningDate: '2024-11-18',
    position: 'Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1500 AZN',
    address: 'Bakı şəhəri, Xəzər rayonu, Şüvəlan qəsəbəsi',
    birthDate: '1992-12-04',
    education: 'Azərbaycan Dövlət Neft və Sənaye Universiteti, Kimya mühendisliyi',
    experience: '2 il təhsil sahəsində təcrübə',
    languages: 'Azərbaycan, İngilis, Meksika',
    specialization: 'Meksika, Argentina universitetləri',
    notes: 'Latın Amerikası ölkələri üzrə mütəxəssis',
    emergencyContact: 'Bayram Bayramov (Ata)',
    emergencyPhone: '+994704567891'
  },
  { 
    id: 24, 
    name: 'Samir Əsgərov', 
    email: 'samir@unidestin.az', 
    phone: '+994515678901', 
    isActive: true, 
    joiningDate: '2024-12-01',
    position: 'Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1350 AZN',
    address: 'Bakı şəhəri, Səbail rayonu, Bayıl qəsəbəsi',
    birthDate: '1998-06-19',
    education: 'Azərbaycan Dövlət İqtisad Universiteti, Maliyyə fakültəsi',
    experience: '6 ay təhsil məsləhətçiliği təcrübəsi',
    languages: 'Azərbaycan, İngilis, Koreya',
    specialization: 'Cənubi Koreya universitetləri',
    notes: 'Ən yeni konsultant, çox perspektivli',
    emergencyContact: 'Əsgər Əsgərov (Ata)',
    emergencyPhone: '+994515678902'
  },
  { 
    id: 25, 
    name: 'Zeynəb Mustafayeva', 
    email: 'zeyneb@unidestin.az', 
    phone: '+994556789012', 
    isActive: true, 
    joiningDate: '2024-12-10',
    position: 'Konsultant',
    department: 'Beynəlxalq Təhsil',
    salary: '1450 AZN',
    address: 'Bakı şəhəri, Yasamal rayonu, Yasamal qəsəbəsi',
    birthDate: '1993-08-26',
    education: 'Azərbaycan Dövlət Pedaqoji Universiteti, Xarici dillər fakültəsi',
    experience: '2 il təhsil sahəsində təcrübə',
    languages: 'Azərbaycan, İngilis, Ərəb, Fars',
    specialization: 'İran, Əfqanıstan, Pakistan universitetləri',
    notes: 'Orta Şərq ölkələri üzrə mütəxəssis',
    emergencyContact: 'Mustafa Mustafayev (Ata)',
    emergencyPhone: '+994556789013'
  }
];

export const studentRequestStatuses = [
  { id: 1, name: 'Yeni müraciət', color: '#3B82F6' },
  { id: 2, name: 'Görüş təyin edildi', color: '#F59E0B' },
  { id: 3, name: 'Sənəd gözlənilir', color: '#EF4444' },
  { id: 4, name: 'Sənədlər tamamlandı', color: '#8B5CF6' },
  { id: 5, name: 'Universitetə müraciət edildi', color: '#06B6D4' },
  { id: 6, name: 'Qəbul alıb', color: '#10B981' },
  { id: 7, name: 'İmtina edildi', color: '#6B7280' },
];

export const students = [
  {
    id: 1,
    firstName: 'Nigar',
    lastName: 'Rəhimova',
    phone: '+994502345678',
    email: 'nigar.rehimova@gmail.com',
    birthDate: '1999-05-15',
    address: 'Bakı şəhəri, Nəsimi rayonu, Nizami küçəsi 45',
    parentPhone: '+994502345677',
    parentName: 'Rəhim Rəhimov',
    source: 'Instagram',
    firstContactDate: '2024-01-15',
    statusId: 1,
    status: 'Yeni müraciət',
    followUpDone: false,
    lastFollowUpDate: null,
    consultantId: 1,
    consultant: 'Əli Məmmədov',
    educationLevel: 'Magistr',
    specialization: 'İqtisadiyyat',
    currentYear: '4',
    currentUniversity: 'ADA Universiteti',
    interestedCountries: 'Almaniya, İngiltərə',
    financialForecast: 'Valideynlər qarşılayacaq',
    tuitionFeeRange: '5000-8000 EUR',
    languageExam: 'IELTS 6.5',
    languageExamDate: '2024-02-20',
    otherExams: 'GRE 320',
    gpa: '87.5 / 100',
    generalNotes: 'Çox motivasiyalı tələbə, tez cavab verir',
    appliedUniversities: 'Technical University of Munich, University of Oxford',
    appliedPrograms: [1, 2], // Computer Science, Business Administration
    appliedScholarships: [1, 2], // DAAD, Chevening
    requiredDocuments: 'Diplom tərcüməsi, Motivasiya məktubu, CV',
    isActive: true,
    statusHistory: [
      {
        id: 1,
        fromStatusId: null,
        fromStatus: null,
        toStatusId: 1,
        toStatus: 'Yeni müraciət',
        changedBy: 'Əli Məmmədov',
        changedById: 1,
        changeDate: '2024-01-15',
        changeTime: '09:30',
        reason: 'İlk müraciət qeydiyyatı',
        notes: 'Instagram vasitəsilə əlaqə saxladı'
      }
    ],
    sentRecommendations: [
      {
        id: 1,
        sentDate: '2024-01-20',
        sentTime: '14:30',
        sentBy: 'Əli Məmmədov',
        sentById: 1,
        universities: [
          {
            universityId: 1,
            universityName: 'Technical University of Munich',
            programId: 1,
            programName: 'Computer Science',
            degree: 'Magistr',
            tuition: '8000 EUR',
            deadline: '2024-03-15'
          },
          {
            universityId: 2,
            universityName: 'University of Oxford',
            programId: 2,
            programName: 'Business Administration',
            degree: 'Magistr',
            tuition: '45000 GBP',
            deadline: '2024-02-28'
          }
        ],
        studentResponse: 'Gözlənilir',
        notes: 'İqtisadiyyat sahəsində 2 universitet təklifi göndərildi'
      }
    ],
    applications: [
      {
        id: 1,
        universityId: 1,
        university: 'Technical University of Munich',
        programId: 1,
        program: 'Computer Science',
        applicationDate: '2024-01-15',
        status: 'Müraciət göndərildi',
        deadline: '2024-03-15',
        requiredDocuments: 'Diplom, Transkript, CV',
        notes: 'Sənədlər hazırdır'
      },
      {
        id: 2,
        universityId: 2,
        university: 'University of Oxford',
        programId: 2,
        program: 'Business Administration',
        applicationDate: '2024-01-20',
        status: 'Cavab gözlənilir',
        deadline: '2024-02-28',
        requiredDocuments: 'Personal Statement, References',
        notes: 'İngilis dili imtahanı tələb olunur'
      }
    ]
  },
  {
    id: 2,
    firstName: 'Cavid',
    lastName: 'Əsgərov',
    phone: '+994553456789',
    email: 'cavid.asgarov@yahoo.com',
    birthDate: '2001-08-12',
    address: 'Bakı şəhəri, Yasamal rayonu, Həsən bəy Zərdabi küçəsi 89',
    parentPhone: '+994553456788',
    parentName: 'Əsgər Əsgərov',
    source: 'Facebook',
    firstContactDate: '2024-01-20',
    statusId: 3,
    status: 'Sənəd gözlənilir',
    followUpDone: true,
    lastFollowUpDate: '2024-01-25',
    consultantId: 2,
    consultant: 'Ayşə Həsənova',
    educationLevel: 'Bakalavr',
    specialization: 'Komputer Mühendisliyi',
    currentYear: '12',
    currentUniversity: 'Məktəb (son sinif)',
    interestedCountries: 'ABŞ, Kanada',
    financialForecast: 'Təqaüd axtarır',
    tuitionFeeRange: '10000-15000 USD',
    languageExam: 'TOEFL 95',
    languageExamDate: '2024-01-10',
    otherExams: 'SAT 1450',
    gpa: '92.3 / 100',
    generalNotes: 'Çox güclü akademik nəticələri var',
    appliedUniversities: 'Harvard University, University of Toronto',
    appliedPrograms: [3, 4], // Medicine, Engineering
    appliedScholarships: [3, 4], // Fulbright, Vanier Canada
    requiredDocuments: 'Transkript, Bank arayışı, Referans məktubları',
    isActive: true,
    statusHistory: [
      {
        id: 1,
        fromStatusId: null,
        fromStatus: null,
        toStatusId: 1,
        toStatus: 'Yeni müraciət',
        changedBy: 'Ayşə Həsənova',
        changedById: 2,
        changeDate: '2024-01-20',
        changeTime: '10:15',
        reason: 'İlk müraciət qeydiyyatı',
        notes: 'Facebook vasitəsilə əlaqə saxladı'
      },
      {
        id: 2,
        fromStatusId: 1,
        fromStatus: 'Yeni müraciət',
        toStatusId: 2,
        toStatus: 'Görüş təyin edildi',
        changedBy: 'Ayşə Həsənova',
        changedById: 2,
        changeDate: '2024-01-22',
        changeTime: '15:45',
        reason: 'Ilk görüş təyin edildi',
        notes: 'Zoom vasitəsilə görüş planlaşdırıldı'
      },
      {
        id: 3,
        fromStatusId: 2,
        fromStatus: 'Görüş təyin edildi',
        toStatusId: 3,
        toStatus: 'Sənəd gözlənilir',
        changedBy: 'Ayşə Həsənova',
        changedById: 2,
        changeDate: '2024-01-25',
        changeTime: '11:20',
        reason: 'Görüş keçirildi, sənədlər tələb olundu',
        notes: 'Bank arayışı və referans məktubları gözlənilir'
      }
    ],
    sentRecommendations: [
      {
        id: 1,
        sentDate: '2024-01-25',
        sentTime: '16:00',
        sentBy: 'Ayşə Həsənova',
        sentById: 2,
        universities: [
          {
            universityId: 3,
            universityName: 'Harvard University',
            programId: 3,
            programName: 'Medicine',
            degree: 'Doktorantura',
            tuition: '65000 USD',
            deadline: '2024-04-01'
          },
          {
            universityId: 4,
            universityName: 'University of Toronto',
            programId: 4,
            programName: 'Engineering',
            degree: 'Bakalavr',
            tuition: '25000 CAD',
            deadline: '2024-02-01'
          }
        ],
        studentResponse: 'Qəbul edildi',
        notes: 'Hər iki universiteti bəyəndi, müraciət etmək istəyir'
      }
    ],
    applications: [
      {
        id: 3,
        universityId: 3,
        university: 'Harvard University',
        programId: 3,
        program: 'Medicine',
        applicationDate: '2024-01-20',
        status: 'Sənəd gözlənilir',
        deadline: '2024-04-01',
        requiredDocuments: 'SAT, Essays, Medical Experience',
        notes: 'Tibbi təcrübə əlavə etməli'
      }
    ]
  },
  {
    id: 3,
    firstName: 'Səbinə',
    lastName: 'Vəliyeva',
    phone: '+994701234567',
    email: 'sabina.valiyeva@outlook.com',
    birthDate: '1998-11-03',
    address: 'Bakı şəhəri, Səbail rayonu, İçərişəhər 12',
    parentPhone: '+994701234566',
    parentName: 'Vəli Vəliyev',
    source: 'Tövsiyə',
    firstContactDate: '2024-01-25',
    statusId: 4,
    status: 'Sənədlər tamamlandı',
    followUpDone: true,
    lastFollowUpDate: '2024-01-30',
    consultantId: 1,
    consultant: 'Əli Məmmədov',
    educationLevel: 'Magistr',
    specialization: 'Biznes İdarəçiliyi',
    currentYear: '4',
    currentUniversity: 'Bakı Dövlət Universiteti',
    interestedCountries: 'İngiltərə, ABŞ',
    financialForecast: 'Ailə dəstəyi',
    tuitionFeeRange: '30000-50000 USD',
    languageExam: 'IELTS 7.0',
    languageExamDate: '2024-01-05',
    otherExams: 'GMAT 650',
    gpa: '89.2 / 100',
    generalNotes: 'İş təcrübəsi var, liderlik keyfiyyətləri güclü',
    appliedUniversities: 'University of Oxford, Harvard University',
    appliedPrograms: [2], // Business Administration
    appliedScholarships: [2, 6], // Chevening, Erasmus Mundus
    requiredDocuments: 'CV, Motivasiya məktubu, İş referansları',
    isActive: true,
    statusHistory: [
      {
        id: 1,
        fromStatusId: null,
        fromStatus: null,
        toStatusId: 1,
        toStatus: 'Yeni müraciət',
        changedBy: 'Əli Məmmədov',
        changedById: 1,
        changeDate: '2024-01-25',
        changeTime: '09:00',
        reason: 'İlk müraciət qeydiyyatı',
        notes: 'Dostunun tövsiyəsilə gəldi'
      },
      {
        id: 2,
        fromStatusId: 1,
        fromStatus: 'Yeni müraciət',
        toStatusId: 2,
        toStatus: 'Görüş təyin edildi',
        changedBy: 'Əli Məmmədov',
        changedById: 1,
        changeDate: '2024-01-26',
        changeTime: '14:30',
        reason: 'Görüş planlaşdırıldı',
        notes: 'Ofisdə üz-üzə görüş'
      },
      {
        id: 3,
        fromStatusId: 2,
        fromStatus: 'Görüş təyin edildi',
        toStatusId: 3,
        toStatus: 'Sənəd gözlənilir',
        changedBy: 'Əli Məmmədov',
        changedById: 1,
        changeDate: '2024-01-28',
        changeTime: '16:00',
        reason: 'Görüş keçirildi',
        notes: 'İş referansları və GMAT nəticəsi gözlənilir'
      },
      {
        id: 4,
        fromStatusId: 3,
        fromStatus: 'Sənəd gözlənilir',
        toStatusId: 4,
        toStatus: 'Sənədlər tamamlandı',
        changedBy: 'Əli Məmmədov',
        changedById: 1,
        changeDate: '2024-01-30',
        changeTime: '11:15',
        reason: 'Bütün sənədlər təqdim edildi',
        notes: 'Müraciət üçün hazır vəziyyətdə'
      }
    ],
    sentRecommendations: [
      {
        id: 1,
        sentDate: '2024-01-30',
        sentTime: '12:00',
        sentBy: 'Əli Məmmədov',
        sentById: 1,
        universities: [
          {
            universityId: 2,
            universityName: 'University of Oxford',
            programId: 2,
            programName: 'Business Administration',
            degree: 'Magistr',
            tuition: '45000 GBP',
            deadline: '2024-03-01'
          },
          {
            universityId: 3,
            universityName: 'Harvard University',
            programId: 2,
            programName: 'Business Administration',
            degree: 'Magistr',
            tuition: '65000 USD',
            deadline: '2024-04-15'
          }
        ],
        studentResponse: 'Qəbul edildi',
        notes: 'Hər iki təklifi bəyəndi, prioritet Oxford-dur'
      }
    ],
    applications: [
      {
        id: 4,
        universityId: 2,
        university: 'University of Oxford',
        programId: 2,
        program: 'Business Administration',
        applicationDate: '2024-01-25',
        status: 'Sənədlər tamamlandı',
        deadline: '2024-03-01',
        requiredDocuments: 'MBA Essays, Work Experience, GMAT',
        notes: 'Bütün sənədlər hazırdır, cavab gözlənilir'
      },
      {
        id: 5,
        universityId: 3,
        university: 'Harvard University',
        programId: 2,
        program: 'Business Administration',
        applicationDate: '2024-01-28',
        status: 'Müraciət göndərildi',
        deadline: '2024-04-15',
        requiredDocuments: 'Essays, Recommendations, Interview',
        notes: 'Müsahibə üçün dəvət gözlənilir'
      }
    ]
  },
  {
    id: 4,
    firstName: 'Rəşad',
    lastName: 'İbrahimov',
    phone: '+994555987654',
    email: 'rashad.ibrahimov@mail.ru',
    birthDate: '1996-01-18',
    address: 'Bakı şəhəri, Xətai rayonu, Koroğlu küçəsi 156',
    parentPhone: '+994555987653',
    parentName: 'İbrahim İbrahimov',
    source: 'LinkedIn',
    firstContactDate: '2024-02-01',
    statusId: 6,
    status: 'Qəbul alıb',
    followUpDone: true,
    lastFollowUpDate: '2024-02-10',
    consultantId: 3,
    consultant: 'Rəşad Quliyev',
    educationLevel: 'Doktorantura',
    specialization: 'Psixologiya',
    currentYear: 'Magistr məzunu',
    currentUniversity: 'Bakı Slavyan Universiteti',
    interestedCountries: 'İngiltərə, Almaniya',
    financialForecast: 'Təqaüd alıb',
    tuitionFeeRange: '20000-40000 EUR',
    languageExam: 'IELTS 7.5',
    languageExamDate: '2023-12-15',
    otherExams: 'GRE 330',
    gpa: '94.1 / 100',
    generalNotes: 'Təqaüd qazanıb, çox güclü akademik profil',
    appliedUniversities: 'University of Oxford',
    appliedPrograms: [6], // Psychology
    appliedScholarships: [1, 6], // DAAD, Erasmus Mundus
    requiredDocuments: 'Dissertasiya planı, Akademik referanslar',
    isActive: true,
    statusHistory: [
      {
        id: 1,
        fromStatusId: null,
        fromStatus: null,
        toStatusId: 1,
        toStatus: 'Yeni müraciət',
        changedBy: 'Rəşad Quliyev',
        changedById: 3,
        changeDate: '2024-02-01',
        changeTime: '10:30',
        reason: 'İlk müraciət qeydiyyatı',
        notes: 'LinkedIn vasitəsilə əlaqə saxladı'
      },
      {
        id: 2,
        fromStatusId: 1,
        fromStatus: 'Yeni müraciət',
        toStatusId: 4,
        toStatus: 'Sənədlər tamamlandı',
        changedBy: 'Rəşad Quliyev',
        changedById: 3,
        changeDate: '2024-02-05',
        changeTime: '14:00',
        reason: 'Bütün sənədlər mövcud idi',
        notes: 'Çox güclü profil, dərhal müraciət edildi'
      },
      {
        id: 3,
        fromStatusId: 4,
        fromStatus: 'Sənədlər tamamlandı',
        toStatusId: 5,
        toStatus: 'Universitetə müraciət edildi',
        changedBy: 'Rəşad Quliyev',
        changedById: 3,
        changeDate: '2024-02-06',
        changeTime: '09:30',
        reason: 'Oxford universitetetinə müraciət göndərildi',
        notes: 'Təqaüd üçün də müraciət edildi'
      },
      {
        id: 4,
        fromStatusId: 5,
        fromStatus: 'Universitetə müraciət edildi',
        toStatusId: 6,
        toStatus: 'Qəbul alıb',
        changedBy: 'Rəşad Quliyev',
        changedById: 3,
        changeDate: '2024-02-10',
        changeTime: '16:45',
        reason: 'Universitetdən qəbul məktubu gəldi',
        notes: 'Tam təqaüdlə qəbul edildi!'
      }
    ],
    sentRecommendations: [
      {
        id: 1,
        sentDate: '2024-02-03',
        sentTime: '10:00',
        sentBy: 'Rəşad Quliyev',
        sentById: 3,
        universities: [
          {
            universityId: 2,
            universityName: 'University of Oxford',
            programId: 6,
            programName: 'Psychology',
            degree: 'Doktorantura',
            tuition: '38000 GBP',
            deadline: '2024-01-31'
          }
        ],
        studentResponse: 'Dərhal qəbul edildi',
        notes: 'Çox güclü profil olduğu üçün təkcə Oxford təklif edildi'
      }
    ],
    applications: [
      {
        id: 6,
        universityId: 2,
        university: 'University of Oxford',
        programId: 6,
        program: 'Psychology',
        applicationDate: '2024-02-01',
        status: 'Qəbul alıb',
        deadline: '2024-01-31',
        requiredDocuments: 'Research Proposal, Academic References',
        notes: 'Tam təqaüd ilə qəbul edilib, sentyabrda başlayır'
      }
    ]
  },
  {
    id: 5,
    firstName: 'Leyla',
    lastName: 'Həsənova',
    phone: '+994516789012',
    email: 'leyla.hasanova@gmail.com',
    birthDate: '2000-07-22',
    address: 'Bakı şəhəri, Nərimanov rayonu, Ahmad Rajabli küçəsi 78',
    parentPhone: '+994516789011',
    parentName: 'Həsən Həsənov',
    source: 'Sayt',
    firstContactDate: '2024-02-05',
    statusId: 2,
    status: 'Görüş təyin edildi',
    followUpDone: false,
    lastFollowUpDate: null,
    consultantId: 2,
    consultant: 'Ayşə Həsənova',
    educationLevel: 'Bakalavr',
    specialization: 'Beynəlxalq Münasibətlər',
    currentYear: '3',
    currentUniversity: 'Azərbaycan Dövlət İqtisad Universiteti',
    interestedCountries: 'Türkiyə, İtaliya',
    financialForecast: 'Qarışıq maliyyələşdirmə',
    tuitionFeeRange: '8000-15000 EUR',
    languageExam: 'IELTS 6.0',
    languageExamDate: '2024-01-30',
    otherExams: 'YÖS 420',
    gpa: '85.7 / 100',
    generalNotes: 'Erasmus proqramlarına marağı var',
    appliedUniversities: '',
    appliedPrograms: [],
    appliedScholarships: [],
    requiredDocuments: 'Hələ başlanmayıb',
    isActive: true,
    statusHistory: [
      {
        id: 1,
        fromStatusId: null,
        fromStatus: null,
        toStatusId: 1,
        toStatus: 'Yeni müraciət',
        changedBy: 'Ayşə Həsənova',
        changedById: 2,
        changeDate: '2024-02-05',
        changeTime: '11:45',
        reason: 'İlk müraciət qeydiyyatı',
        notes: 'Vebsayt vasitəsilə əlaqə saxladı'
      },
      {
        id: 2,
        fromStatusId: 1,
        fromStatus: 'Yeni müraciət',
        toStatusId: 2,
        toStatus: 'Görüş təyin edildi',
        changedBy: 'Ayşə Həsənova',
        changedById: 2,
        changeDate: '2024-02-06',
        changeTime: '09:15',
        reason: 'Görüş planlaşdırıldı',
        notes: '2024-02-08 tarixində görüş təyin edildi'
      }
    ],
    sentRecommendations: [],
    applications: []
  }
];

// Dashboard statistics mock data
export const dashboardStats = {
  totalStudents: 45,
  newRequests: 12,
  activeConsultants: 3,
  acceptedStudents: 23,
  monthlyGrowth: 15.5,
  recentActivities: [
    { id: 1, text: 'Nigar Rəhimova yeni müraciət etdi', time: '2 saat əvvəl', type: 'new' },
    { id: 2, text: 'Cavid Əsgərov qəbul aldı', time: '5 saat əvvəl', type: 'success' },
    { id: 3, text: 'Ayşə Həsənova tələbə ilə görüş keçirdi', time: '1 gün əvvəl', type: 'meeting' },
    { id: 4, text: 'Yeni universitet əlavə edildi', time: '2 gün əvvəl', type: 'info' },
  ]
};

// Dropdown options
export const sourcesOptions = [
  'Instagram',
  'Facebook', 
  'WhatsApp',
  'Zəng',
  'Tövsiyə',
  'Sayt',
  'LinkedIn',
  'Digər'
];

export const educationLevels = [
  'Magistr',
  'Bakalavr', 
  'Doktorantura',
  'Dil məktəbi',
  'Orta məktəb',
  'Kurs/Kollec',
  'Transfer'
];

export const scholarships = [
  {
    id: 1,
    name: 'DAAD Scholarship Program',
    description: 'Almaniya hökumətinin təhsil təqaüd proqramı. Magistr və doktorantura səviyyəsində təqaüd imkanları.',
    universityId: 1,
    university: 'Technical University of Munich',
    country: 'Almaniya',
    city: 'München',
    degreeLevel: 'Magistr, Doktorantura',
    fieldOfStudy: 'Mühendislik, Fen Elmləri, İqtisadiyyat',
    amount: '861',
    currency: 'EUR',
    amountType: 'Aylıq',
    coverageType: 'Tam təqaüd',
    applicationDeadline: '31 Oktyabr 2024',
    requirements: 'IELTS 6.5+, GPA 3.5+, Motivasiya məktubu, CV, Referans məktubları',
    applicationProcess: 'DAAD portalından online müraciət',
    contactEmail: 'info@daad.de',
    website: 'https://www.daad.de',
    isActive: true,
    createdAt: '2024-01-10',
    additionalBenefits: 'Yaşayış yardımı, səyahət təqaüdü, sağlamlıq sığortası',
    duration: '12-24 ay'
  },
  {
    id: 2,
    name: 'Chevening Scholarship',
    description: 'İngiltərə hökumətinin prestijli təqaüd proqramı. Dünyanın hər yerindən tələbələr üçün tam təqaüd.',
    universityId: 2,
    university: 'University of Oxford',
    country: 'İngiltərə',
    city: 'London',
    degreeLevel: 'Magistr',
    fieldOfStudy: 'Bütün sahələr',
    amount: '18000',
    currency: 'GBP',
    amountType: 'İllik',
    coverageType: 'Tam təqaüd',
    applicationDeadline: '2 Noyabr 2024',
    requirements: 'IELTS 6.5+, İş təcrübəsi 2+ il, Liderlik keyfiyyətləri',
    applicationProcess: 'Chevening vebsaytından müraciət',
    contactEmail: 'contact@chevening.org',
    website: 'https://www.chevening.org',
    isActive: true,
    createdAt: '2024-01-12',
    additionalBenefits: 'Yaşayış, səyahət, kitab və tez xərcləri',
    duration: '12 ay'
  },
  {
    id: 3,
    name: 'Fulbright Graduate Program',
    description: 'ABŞ hökumətinin beynəlxalq tələbə dəyişimi proqramı. Magistr və doktorantura üçün tam təqaüd.',
    universityId: 3,
    university: 'Harvard University',
    country: 'ABŞ',
    city: 'New York',
    degreeLevel: 'Magistr, Doktorantura',
    fieldOfStudy: 'Elm, Texnologiya, Humanitar elmlər',
    amount: '25000',
    currency: 'USD',
    amountType: 'İllik',
    coverageType: 'Tam təqaüd',
    applicationDeadline: '15 Oktyabr 2024',
    requirements: 'TOEFL 100+, GRE/GMAT, Tədqiqat təklifi, Referanslar',
    applicationProcess: 'Fulbright komissiyası vasitəsilə müraciət',
    contactEmail: 'info@fulbright.org',
    website: 'https://www.fulbright.org',
    isActive: true,
    createdAt: '2024-01-15',
    additionalBenefits: 'Sağlamlıq sığortası, komputer təqaüdü, tədris materialları',
    duration: '9-12 ay'
  },
  {
    id: 4,
    name: 'Vanier Canada Graduate Scholarships',
    description: 'Kanadanın ən prestijli doktorantura təqaüd proqramı. Dünya səviyyəsində tədqiqatçılar üçün.',
    universityId: 4,
    university: 'University of Toronto',
    country: 'Kanada',
    city: 'Toronto',
    degreeLevel: 'Doktorantura',
    fieldOfStudy: 'Təbii elmlər, Mühendislik, Sosial elmlər',
    amount: '50000',
    currency: 'CAD',
    amountType: 'İllik',
    coverageType: 'Tam təqaüd',
    applicationDeadline: '1 Noyabr 2024',
    requirements: 'Üstün akademik nəticələr, Tədqiqat təcrübəsi, Referanslar',
    applicationProcess: 'Universitet vasitəsilə nominasiya',
    contactEmail: 'vanier@nserc-crsng.gc.ca',
    website: 'https://vanier.gc.ca',
    isActive: false,
    createdAt: '2024-01-18',
    additionalBenefits: 'Tədqiqat fondları, konferens dəstəyi',
    duration: '36 ay'
  },
  {
    id: 5,
    name: 'Australia Awards Scholarship',
    description: 'Avstraliya hökumətinin inkişaf edən ölkələr üçün təqaüd proqramı.',
    universityId: 5,
    university: 'University of Sydney',
    country: 'Avstriyalya',
    city: 'Sidney',
    degreeLevel: 'Bakalavr, Magistr',
    fieldOfStudy: 'İdarəetmə, Mühendislik, Kənd təsərrüfatı',
    amount: '30000',
    currency: 'AUD',
    amountType: 'İllik',
    coverageType: 'Tam təqaüd',
    applicationDeadline: '30 Aprel 2024',
    requirements: 'IELTS 6.5+, İş təcrübəsi, Gələcək planları',
    applicationProcess: 'Australia Awards portalından müraciət',
    contactEmail: 'info@australiaawards.gov.au',
    website: 'https://www.australiaawards.gov.au',
    isActive: true,
    createdAt: '2024-01-20',
    additionalBenefits: 'Yaşayış, tibbi sığorta, preparatory kurslar',
    duration: '12-48 ay'
  },
  {
    id: 6,
    name: 'Erasmus Mundus Joint Masters',
    description: 'Avropa Birliyi\'nin beynəlxalq magistr proqramları üçün təqaüd imkanları.',
    universityId: 2,
    university: 'University of Oxford',
    country: 'İngiltərə',
    city: 'London',
    degreeLevel: 'Magistr',
    fieldOfStudy: 'Mühendislik, İT, Biznes, Ədəbiyyat',
    amount: '1400',
    currency: 'EUR',
    amountType: 'Aylıq',
    coverageType: 'Qismən təqaüd',
    applicationDeadline: '15 Yanvar 2025',
    requirements: 'IELTS 6.5+, Bakalavr diplomu, Motivasiya məktubu',
    applicationProcess: 'Hər proqramın öz portal sistemi',
    contactEmail: 'info@erasmusmundus.eu',
    website: 'https://www.erasmusmundus.eu',
    isActive: true,
    createdAt: '2024-01-25',
    additionalBenefits: 'Mobility təqaüdü, kulturel təcrübə',
    duration: '24 ay'
  }
];

// Contract Management System
export const contractStatuses = [
  { id: 1, name: 'Hazırlanır', color: 'yellow' },
  { id: 2, name: 'İmzalanmağa göndərildi', color: 'blue' },
  { id: 3, name: 'İmzalandı', color: 'green' },
  { id: 4, name: 'Aktiv', color: 'green' },
  { id: 5, name: 'Tamamlandı', color: 'gray' },
  { id: 6, name: 'Ləğv edildi', color: 'red' }
];

export const paymentStatuses = [
  { id: 1, name: 'Gözlənilir', color: 'yellow' },
  { id: 2, name: 'Qismən ödənilib', color: 'orange' },
  { id: 3, name: 'Tam ödənilib', color: 'green' },
  { id: 4, name: 'Gecikir', color: 'red' },
  { id: 5, name: 'Ləğv edildi', color: 'gray' }
];

export const serviceTypes = [
  { id: 1, name: 'Universitet müraciəti', price: 500, currency: 'AZN' },
  { id: 2, name: 'Viza dəstəyi', price: 300, currency: 'AZN' },
  { id: 3, name: 'Sənəd tərcüməsi', price: 50, currency: 'AZN' },
  { id: 4, name: 'Məsləhət xidməti', price: 200, currency: 'AZN' },
  { id: 5, name: 'Tam paket', price: 1000, currency: 'AZN' },
  { id: 6, name: 'Təqaüd müraciəti', price: 400, currency: 'AZN' }
];

export const contracts = [
  {
    id: 1,
    contractNumber: 'UNI-2024-001',
    studentId: 3,
    studentName: 'Səbinə Vəliyeva',
    consultantId: 1,
    consultantName: 'Əli Məmmədov',
    universityId: 2,
    universityName: 'University of Oxford',
    programId: 2,
    programName: 'Business Administration',
    services: [
      { serviceId: 1, serviceName: 'Universitet müraciəti', price: 500, currency: 'AZN' },
      { serviceId: 2, serviceName: 'Viza dəstəyi', price: 300, currency: 'AZN' }
    ],
    totalAmount: 800,
    currency: 'AZN',
    contractDate: '2024-02-01',
    startDate: '2024-02-01',
    endDate: '2024-09-01',
    statusId: 4,
    status: 'Aktiv',
    paymentType: 'Hissəli', // Tam, Hissəli
    paymentSchedule: [
      {
        id: 1,
        amount: 400,
        currency: 'AZN',
        dueDate: '2024-02-15',
        description: 'İlk ödəniş (50%)',
        statusId: 3,
        status: 'Tam ödənilib',
        paidDate: '2024-02-14',
        paidAmount: 400
      },
      {
        id: 2,
        amount: 400,
        currency: 'AZN',
        dueDate: '2024-03-15',
        description: 'Son ödəniş (50%)',
        statusId: 1,
        status: 'Gözlənilir',
        paidDate: null,
        paidAmount: 0
      }
    ],
    notes: 'Oxford universiteti üçün tam xidmət paketi',
    isActive: true,
    createdAt: '2024-02-01',
    createdBy: 'Əli Məmmədov'
  },
  {
    id: 2,
    contractNumber: 'UNI-2024-002',
    studentId: 4,
    studentName: 'Rəşad İbrahimov',
    consultantId: 3,
    consultantName: 'Rəşad Quliyev',
    universityId: 2,
    universityName: 'University of Oxford',
    programId: 6,
    programName: 'Psychology',
    services: [
      { serviceId: 5, serviceName: 'Tam paket', price: 1000, currency: 'AZN' }
    ],
    totalAmount: 1000,
    currency: 'AZN',
    contractDate: '2024-02-05',
    startDate: '2024-02-05',
    endDate: '2024-10-01',
    statusId: 4,
    status: 'Aktiv',
    paymentType: 'Tam',
    paymentSchedule: [
      {
        id: 1,
        amount: 1000,
        currency: 'AZN',
        dueDate: '2024-02-10',
        description: 'Tam ödəniş',
        statusId: 3,
        status: 'Tam ödənilib',
        paidDate: '2024-02-08',
        paidAmount: 1000
      }
    ],
    notes: 'Doktorantura üçün tam xidmət paketi, təqaüd dəstəyi daxil',
    isActive: true,
    createdAt: '2024-02-05',
    createdBy: 'Rəşad Quliyev'
  },
  {
    id: 3,
    contractNumber: 'UNI-2024-003',
    studentId: 1,
    studentName: 'Nigar Rəhimova',
    consultantId: 1,
    consultantName: 'Əli Məmmədov',
    universityId: 1,
    universityName: 'Technical University of Munich',
    programId: 1,
    programName: 'Computer Science',
    services: [
      { serviceId: 1, serviceName: 'Universitet müraciəti', price: 500, currency: 'AZN' },
      { serviceId: 6, serviceName: 'Təqaüd müraciəti', price: 400, currency: 'AZN' }
    ],
    totalAmount: 900,
    currency: 'AZN',
    contractDate: '2024-02-10',
    startDate: '2024-02-10',
    endDate: '2024-08-01',
    statusId: 3,
    status: 'İmzalandı',
    paymentType: 'Hissəli',
    paymentSchedule: [
      {
        id: 1,
        amount: 450,
        currency: 'AZN',
        dueDate: '2024-02-20',
        description: 'İlk ödəniş (50%)',
        statusId: 2,
        status: 'Qismən ödənilib',
        paidDate: '2024-02-18',
        paidAmount: 300
      },
      {
        id: 2,
        amount: 450,
        currency: 'AZN',
        dueDate: '2024-03-20',
        description: 'Son ödəniş (50%)',
        statusId: 1,
        status: 'Gözlənilir',
        paidDate: null,
        paidAmount: 0
      }
    ],
    notes: 'Almaniya üçün universitet və təqaüd müraciəti',
    isActive: true,
    createdAt: '2024-02-10',
    createdBy: 'Əli Məmmədov'
  }
];

// Cash Management System
export const transactionTypes = [
  { id: 1, name: 'Gəlir', type: 'income', color: 'green' },
  { id: 2, name: 'Xərc', type: 'expense', color: 'red' }
];

export const incomeCategories = [
  { id: 1, name: 'Müqavilə ödənişi', description: 'Tələbələrdən alınan xidmət haqqı' },
  { id: 2, name: 'Əlavə xidmət', description: 'Sənəd tərcüməsi, məsləhət və s.' },
  { id: 3, name: 'Komissiya', description: 'Universitetlərdən alınan komissiya' },
  { id: 4, name: 'Digər gəlirlər', description: 'Başqa mənbələrdən gəlirlər' }
];

export const expenseCategories = [
  { id: 1, name: 'Əmək haqqı', description: 'İşçilərin maaşları' },
  { id: 2, name: 'Ofis xərcləri', description: 'İcarə, kommunal, internet və s.' },
  { id: 3, name: 'Marketinq', description: 'Reklam və tanıtım xərcləri' },
  { id: 4, name: 'Səyahət', description: 'İş səfərləri və nəqliyyat' },
  { id: 5, name: 'Texniki xərclər', description: 'Proqram təminatı, avadanlıq' },
  { id: 6, name: 'Digər xərclər', description: 'Başqa xərclər' }
];

export const cashTransactions = [
  {
    id: 1,
    transactionNumber: 'TXN-2024-001',
    date: '2024-02-14',
    time: '14:30',
    typeId: 1,
    type: 'Gəlir',
    categoryId: 1,
    category: 'Müqavilə ödənişi',
    amount: 400,
    currency: 'AZN',
    description: 'Səbinə Vəliyeva - İlk ödəniş',
    contractId: 1,
    contractNumber: 'UNI-2024-001',
    studentId: 3,
    studentName: 'Səbinə Vəliyeva',
    paymentMethod: 'Bank köçürməsi',
    reference: 'REF-001-2024',
    processedBy: 'Əli Məmmədov',
    processedById: 1,
    notes: 'Oxford universiteti müraciəti üçün ilk ödəniş',
    isActive: true
  },
  {
    id: 2,
    transactionNumber: 'TXN-2024-002',
    date: '2024-02-08',
    time: '11:15',
    typeId: 1,
    type: 'Gəlir',
    categoryId: 1,
    category: 'Müqavilə ödənişi',
    amount: 1000,
    currency: 'AZN',
    description: 'Rəşad İbrahimov - Tam ödəniş',
    contractId: 2,
    contractNumber: 'UNI-2024-002',
    studentId: 4,
    studentName: 'Rəşad İbrahimov',
    paymentMethod: 'Nəğd',
    reference: 'CASH-002-2024',
    processedBy: 'Rəşad Quliyev',
    processedById: 3,
    notes: 'Doktorantura üçün tam paket ödənişi',
    isActive: true
  },
  {
    id: 3,
    transactionNumber: 'TXN-2024-003',
    date: '2024-02-18',
    time: '16:45',
    typeId: 1,
    type: 'Gəlir',
    categoryId: 1,
    category: 'Müqavilə ödənişi',
    amount: 300,
    currency: 'AZN',
    description: 'Nigar Rəhimova - Qismən ödəniş',
    contractId: 3,
    contractNumber: 'UNI-2024-003',
    studentId: 1,
    studentName: 'Nigar Rəhimova',
    paymentMethod: 'Kart',
    reference: 'CARD-003-2024',
    processedBy: 'Əli Məmmədov',
    processedById: 1,
    notes: 'Almaniya müraciəti üçün qismən ödəniş',
    isActive: true
  },
  {
    id: 4,
    transactionNumber: 'TXN-2024-004',
    date: '2024-02-01',
    time: '09:00',
    typeId: 2,
    type: 'Xərc',
    categoryId: 1,
    category: 'Əmək haqqı',
    amount: 2000,
    currency: 'AZN',
    description: 'Əli Məmmədov - Fevral maaşı',
    contractId: null,
    contractNumber: null,
    studentId: null,
    studentName: null,
    paymentMethod: 'Bank köçürməsi',
    reference: 'SAL-001-2024',
    processedBy: 'İnsan Resursları',
    processedById: null,
    notes: 'Baş konsultant maaşı',
    isActive: true
  },
  {
    id: 5,
    transactionNumber: 'TXN-2024-005',
    date: '2024-02-01',
    time: '09:15',
    typeId: 2,
    type: 'Xərc',
    categoryId: 1,
    category: 'Əmək haqqı',
    amount: 1500,
    currency: 'AZN',
    description: 'Ayşə Həsənova - Fevral maaşı',
    contractId: null,
    contractNumber: null,
    studentId: null,
    studentName: null,
    paymentMethod: 'Bank köçürməsi',
    reference: 'SAL-002-2024',
    processedBy: 'İnsan Resursları',
    processedById: null,
    notes: 'Konsultant maaşı',
    isActive: true
  },
  {
    id: 6,
    transactionNumber: 'TXN-2024-006',
    date: '2024-02-05',
    time: '12:30',
    typeId: 2,
    type: 'Xərc',
    categoryId: 2,
    category: 'Ofis xərcləri',
    amount: 800,
    currency: 'AZN',
    description: 'Ofis icarəsi - Fevral',
    contractId: null,
    contractNumber: null,
    studentId: null,
    studentName: null,
    paymentMethod: 'Bank köçürməsi',
    reference: 'RENT-001-2024',
    processedBy: 'Maliyyə',
    processedById: null,
    notes: 'Aylıq ofis icarə haqqı',
    isActive: true
  }
];

// Payment reminders and notifications
export const paymentReminders = [
  {
    id: 1,
    contractId: 1,
    contractNumber: 'UNI-2024-001',
    studentId: 3,
    studentName: 'Səbinə Vəliyeva',
    paymentId: 2,
    amount: 400,
    currency: 'AZN',
    dueDate: '2024-03-15',
    daysUntilDue: 5,
    reminderType: 'upcoming', // upcoming, overdue
    isActive: true,
    createdAt: '2024-03-10'
  },
  {
    id: 2,
    contractId: 3,
    contractNumber: 'UNI-2024-003',
    studentId: 1,
    studentName: 'Nigar Rəhimova',
    paymentId: 1,
    amount: 150, // remaining amount
    currency: 'AZN',
    dueDate: '2024-02-20',
    daysUntilDue: -10, // overdue
    reminderType: 'overdue',
    isActive: true,
    createdAt: '2024-02-20'
  }
];

// Role and Permission Management System
export const permissions = [
  // Dashboard permissions
  { id: 1, name: 'dashboard.view', displayName: 'Dashboard Görüntülə', module: 'Dashboard', description: 'Dashboard səhifəsini görə bilər' },
  
  // Student permissions
  { id: 2, name: 'students.view', displayName: 'Tələbələri Görüntülə', module: 'Tələbələr', description: 'Tələbə siyahısını görə bilər' },
  { id: 3, name: 'students.create', displayName: 'Tələbə Əlavə Et', module: 'Tələbələr', description: 'Yeni tələbə əlavə edə bilər' },
  { id: 4, name: 'students.edit', displayName: 'Tələbə Redaktə Et', module: 'Tələbələr', description: 'Tələbə məlumatlarını dəyişə bilər' },
  { id: 5, name: 'students.delete', displayName: 'Tələbə Sil', module: 'Tələbələr', description: 'Tələbəni silə bilər' },
  
  // Student Requests permissions
  { id: 6, name: 'requests.view', displayName: 'Müraciətləri Görüntülə', module: 'Müraciətlər', description: 'Tələbə müraciətlərini görə bilər' },
  { id: 7, name: 'requests.create', displayName: 'Müraciət Əlavə Et', module: 'Müraciətlər', description: 'Yeni müraciət əlavə edə bilər' },
  { id: 8, name: 'requests.edit', displayName: 'Müraciət Redaktə Et', module: 'Müraciətlər', description: 'Müraciət məlumatlarını dəyişə bilər' },
  { id: 9, name: 'requests.delete', displayName: 'Müraciət Sil', module: 'Müraciətlər', description: 'Müraciəti silə bilər' },
  { id: 10, name: 'requests.status', displayName: 'Müraciət Statusu Dəyiş', module: 'Müraciətlər', description: 'Müraciət statusunu dəyişə bilər' },
  
  // Contract permissions
  { id: 11, name: 'contracts.view', displayName: 'Müqavilələri Görüntülə', module: 'Müqavilələr', description: 'Müqavilə siyahısını görə bilər' },
  { id: 12, name: 'contracts.create', displayName: 'Müqavilə Əlavə Et', module: 'Müqavilələr', description: 'Yeni müqavilə əlavə edə bilər' },
  { id: 13, name: 'contracts.edit', displayName: 'Müqavilə Redaktə Et', module: 'Müqavilələr', description: 'Müqavilə məlumatlarını dəyişə bilər' },
  { id: 14, name: 'contracts.delete', displayName: 'Müqavilə Sil', module: 'Müqavilələr', description: 'Müqaviləni silə bilər' },
  { id: 15, name: 'contracts.payments', displayName: 'Ödəniş İdarəetməsi', module: 'Müqavilələr', description: 'Ödəniş planlarını idarə edə bilər' },
  
  // Cash Management permissions
  { id: 16, name: 'cash.view', displayName: 'Kassa Görüntülə', module: 'Kassa', description: 'Kassa əməliyyatlarını görə bilər' },
  { id: 17, name: 'cash.create', displayName: 'Kassa Əməliyyatı Əlavə Et', module: 'Kassa', description: 'Yeni kassa əməliyyatı əlavə edə bilər' },
  { id: 18, name: 'cash.edit', displayName: 'Kassa Əməliyyatı Redaktə Et', module: 'Kassa', description: 'Kassa əməliyyatını dəyişə bilər' },
  { id: 19, name: 'cash.delete', displayName: 'Kassa Əməliyyatı Sil', module: 'Kassa', description: 'Kassa əməliyyatını silə bilər' },
  { id: 20, name: 'cash.categories', displayName: 'Kassa Kateqoriyaları', module: 'Kassa', description: 'Kassa kateqoriyalarını idarə edə bilər' },
  
  // University permissions
  { id: 21, name: 'universities.view', displayName: 'Universitetləri Görüntülə', module: 'Universitetlər', description: 'Universitet siyahısını görə bilər' },
  { id: 22, name: 'universities.create', displayName: 'Universitet Əlavə Et', module: 'Universitetlər', description: 'Yeni universitet əlavə edə bilər' },
  { id: 23, name: 'universities.edit', displayName: 'Universitet Redaktə Et', module: 'Universitetlər', description: 'Universitet məlumatlarını dəyişə bilər' },
  { id: 24, name: 'universities.delete', displayName: 'Universitet Sil', module: 'Universitetlər', description: 'Universiteti silə bilər' },
  
  // Consultant permissions
  { id: 25, name: 'consultants.view', displayName: 'Konsultantları Görüntülə', module: 'Konsultantlar', description: 'Konsultant siyahısını görə bilər' },
  { id: 26, name: 'consultants.create', displayName: 'Konsultant Əlavə Et', module: 'Konsultantlar', description: 'Yeni konsultant əlavə edə bilər' },
  { id: 27, name: 'consultants.edit', displayName: 'Konsultant Redaktə Et', module: 'Konsultantlar', description: 'Konsultant məlumatlarını dəyişə bilər' },
  { id: 28, name: 'consultants.delete', displayName: 'Konsultant Sil', module: 'Konsultantlar', description: 'Konsultantı silə bilər' },
  
  // System permissions
  { id: 29, name: 'system.users', displayName: 'İstifadəçi İdarəetməsi', module: 'Sistem', description: 'İstifadəçiləri idarə edə bilər' },
  { id: 30, name: 'system.roles', displayName: 'Rol İdarəetməsi', module: 'Sistem', description: 'Rolları idarə edə bilər' },
  { id: 31, name: 'system.permissions', displayName: 'İcazə İdarəetməsi', module: 'Sistem', description: 'İcazələri idarə edə bilər' },
  { id: 32, name: 'system.settings', displayName: 'Sistem Tənzimləmələri', module: 'Sistem', description: 'Sistem tənzimləmələrini dəyişə bilər' },
  { id: 33, name: 'system.backup', displayName: 'Yedəkləmə', module: 'Sistem', description: 'Sistem yedəkləməsi edə bilər' },
  
  // Reports permissions
  { id: 34, name: 'reports.financial', displayName: 'Maliyyə Hesabatları', module: 'Hesabatlar', description: 'Maliyyə hesabatlarını görə bilər' },
  { id: 35, name: 'reports.students', displayName: 'Tələbə Hesabatları', module: 'Hesabatlar', description: 'Tələbə hesabatlarını görə bilər' },
  { id: 36, name: 'reports.export', displayName: 'Hesabat İxracı', module: 'Hesabatlar', description: 'Hesabatları ixrac edə bilər' }
];

export const roles = [
  {
    id: 1,
    name: 'Super Admin',
    description: 'Sistemin tam idarəetmə icazələri',
    color: 'red',
    isActive: true,
    isSystem: true,
    permissionIds: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36], // All permissions
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: 2,
    name: 'Admin',
    description: 'Əsas idarəetmə icazələri',
    color: 'blue',
    isActive: true,
    isSystem: true,
    permissionIds: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,21,22,23,24,25,26,27,28,34,35,36], // Most permissions except system management
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: 3,
    name: 'Konsultant',
    description: 'Tələbə və müraciət idarəetməsi',
    color: 'green',
    isActive: true,
    isSystem: true,
    permissionIds: [1,2,3,4,6,7,8,9,10,11,12,13,15,21,25,35], // Student, request, contract related
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: 4,
    name: 'Mühasib',
    description: 'Maliyyə və kassa idarəetməsi',
    color: 'yellow',
    isActive: true,
    isSystem: true,
    permissionIds: [1,11,15,16,17,18,19,20,34,36], // Financial operations
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: 5,
    name: 'Menecer',
    description: 'Hesabat və nəzarət icazələri',
    color: 'purple',
    isActive: true,
    isSystem: true,
    permissionIds: [1,2,6,11,16,21,25,34,35,36], // View and report permissions
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  }
];

export const users = [
  {
    id: 1,
    username: 'superadmin',
    email: 'superadmin@unidestin.az',
    firstName: 'Super',
    lastName: 'Admin',
    fullName: 'Super Admin',
    roleId: 1,
    roleName: 'Super Admin',
    isActive: true,
    lastLogin: '2024-03-15T10:30:00Z',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-03-15T10:30:00Z'
  },
  {
    id: 2,
    username: 'admin',
    email: 'admin@unidestin.az',
    firstName: 'Əli',
    lastName: 'Məmmədov',
    fullName: 'Əli Məmmədov',
    roleId: 2,
    roleName: 'Admin',
    isActive: true,
    lastLogin: '2024-03-15T09:15:00Z',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-03-15T09:15:00Z'
  },
  {
    id: 3,
    username: 'ayse.consultant',
    email: 'ayse@unidestin.az',
    firstName: 'Ayşə',
    lastName: 'Həsənova',
    fullName: 'Ayşə Həsənova',
    roleId: 3,
    roleName: 'Konsultant',
    isActive: true,
    lastLogin: '2024-03-15T08:45:00Z',
    createdAt: '2024-01-15T00:00:00Z',
    updatedAt: '2024-03-15T08:45:00Z'
  },
  {
    id: 4,
    username: 'resad.consultant',
    email: 'resad@unidestin.az',
    firstName: 'Rəşad',
    lastName: 'Quliyev',
    fullName: 'Rəşad Quliyev',
    roleId: 3,
    roleName: 'Konsultant',
    isActive: true,
    lastLogin: '2024-03-14T16:20:00Z',
    createdAt: '2024-01-15T00:00:00Z',
    updatedAt: '2024-03-14T16:20:00Z'
  },
  {
    id: 5,
    username: 'leyla.accountant',
    email: 'leyla@unidestin.az',
    firstName: 'Leyla',
    lastName: 'Əliyeva',
    fullName: 'Leyla Əliyeva',
    roleId: 4,
    roleName: 'Mühasib',
    isActive: true,
    lastLogin: '2024-03-15T07:30:00Z',
    createdAt: '2024-02-01T00:00:00Z',
    updatedAt: '2024-03-15T07:30:00Z'
  },
  {
    id: 6,
    username: 'farid.manager',
    email: 'farid@unidestin.az',
    firstName: 'Farid',
    lastName: 'Həsənov',
    fullName: 'Farid Həsənov',
    roleId: 5,
    roleName: 'Menecer',
    isActive: true,
    lastLogin: '2024-03-14T18:00:00Z',
    createdAt: '2024-02-01T00:00:00Z',
    updatedAt: '2024-03-14T18:00:00Z'
  }
]; 